export default {
	faqGroups: [],
}